import React, { useEffect, useState } from "react";
import "./Investments.css";
import Banner from "../Banner/Banner";

const SALONAPI = process.env.REACT_APP_SOMPROP_API_EXTERNAL;

const Investments = () => {
  const [historyOfValueCreation, setHistoryOfValueCreation] = useState("");
  const [capitalAbundantContent, setCapitalAbundantContent] = useState("");
  const [caseStudies, setCaseStudies] = useState([]);
  const [loading, setloading] = useState(false)
  const [capitalloading , setcapitalloading] = useState(false);
  const [caseStudyloading, setcaseStudyloading] = useState(false)
  useEffect(() => {
    const apiUrl =`${SALONAPI}/history_of_value_creation`;
    fetchData(apiUrl)
      .then((data) => {
        setHistoryOfValueCreation(
          data?.website_settings?.history_of_value_creation || ""
        );
        setloading(true)
      })
      .catch((error) => {
        console.error("Error fetching history of value creation:", error);
      });

    const capitalUrl = `${SALONAPI}/capital_abundant_content`;
    

    fetchData(capitalUrl)
      .then((data) => {
        setCapitalAbundantContent(
          data?.website_settings?.capital_abundant_content || ""  
        );
        setcapitalloading(true)
      })
      .catch((error) => {
        console.error("Error fetching capital abundant content:", error);
      });


    const caseStudyUrl = `${SALONAPI}/caseStudydata`;

    fetchData(caseStudyUrl)
      .then((data) => {
        setCaseStudies(
          data?.map((item) => ({
            name: item.gallery_title.split("~")[0],
            title: item.gallery_title.split("~")[1],
            image: item.gallery_image,
            description: item.gallery_description,
          })) || []
        );
        setcaseStudyloading(true)
      })
      .catch((error) => {
        console.error("Error fetching case studies:", error);
      });
  }, []);

  const fetchData = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return await response.json();
    } catch (error) {
      throw new Error("Fetch failed:", error.message);
    }
  };

  return (
    <div>
      <Banner>
        <div className="inner-banner-position">
          <h2>INVESTMENTS</h2>
        </div>
      </Banner>
      {
        loading ? (<div
          className="history-section"
          dangerouslySetInnerHTML={{ __html: historyOfValueCreation }}
        ></div>) : (  <section style={{paddingTop:'83px'}}>
        <div className="container">
          <div className="shimmer" style={{minHeight:'25px',display:'block',width:'200px',borderRadius:'5px',marginBottom:'20px  '}}></div>

          <div className="row" style={{marginBottom:'40px'}}>
            <div className="wg-half" style={{width:'100%',marginRight:'20px'}}>
              <div className="shimmer" style={{minHeight:'25px',display:'block',marginBottom:'20px',borderRadius:'5px',width:'400px'}}></div>

              <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'100%'}}></div>

              <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'95%'}}></div>

              <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'90%'}}></div>
            </div>

            <div className="wg-half" style={{width:'100%',marginRight:'20px'}}>
              <div className="shimmer" style={{minHeight:'25px',display:'block',marginBottom:'20px',borderRadius:'5px',width:'400px'}}></div>

              <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'100%'}}></div>

              <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'95%'}}></div>

              <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'90%'}}></div>
            </div>

          </div>
        
        </div>
     </section>)
      }
      

      <div className="properties-parallax">
        <div className="parallax-max">
          <h2>100 Properties / $1 billion</h2>
          <p>
            Since the firm’s inception, we have acquired and repositioned over
            100 properties with a gross asset value upon stabilization of over
            $1 billion.
          </p>
        </div>
      </div>


      {
        capitalloading ? (<div
          className="capital-section"
          dangerouslySetInnerHTML={{ __html: capitalAbundantContent }}
        ></div>) : (<div className="capital-section shimmer" style={{minHeight:'600px', display:'block',margin:'80px auto',borderRadius:'20px'}}></div>)
      }
      

      <div className="container">
        <div className="recent-projects-section">
          <h3>Case Study</h3>
          <div className="row" id="case_study">
            {
              caseStudyloading && caseStudyloading ? (<> { caseStudies.map((study, index) => (
                <div className="col-md-3 col-sm-6 col-12" key={index}>
                  <div className="recent-project-box">
                    <h4>{study.name}</h4>
                    <div className="recent-project-img">
                      <img
                        src={study.image}
                        width="348"
                        height="259"
                        alt={study.name}
                      />
                    </div>
                    <h5>{study.title}</h5>
                    <p>{study.description}</p>
                  </div>
                </div>
              ))}</>) : (<>
              <div className="row">
              <div className="grid-info shimmer" style={{minHeight:'250px',display:'block',width:'23%',marginRight:'14px'}}></div>
              <div className="grid-info shimmer" style={{minHeight:'250px',display:'block',width:'23%',marginRight:'14px'}}></div>
              <div className="grid-info shimmer" style={{minHeight:'250px',display:'block',width:'23%',marginRight:'14px'}}></div>
              <div className="grid-info shimmer" style={{minHeight:'250px',display:'block',width:'23%',marginRight:'14px'}}></div>
              </div>
              </>)
            }
        
          </div>
        </div>
      </div>
    </div>
  );
};

export default Investments;
